$(function () {
    if ($(window).width() > 991) {
        var trigger = $('.changeImageTrigger')

        function replaceImage(element) {
            var replaceImage = element.parents('.changeImage').find('.changeImageHolder img');
            var image = element.data('image');
            replaceImage.attr('src', image)
        }

        function resetImage(element) {
            var replaceImage = element.find('.changeImageHolder img');
            var original = element.find('.changeImageHolder img').data('original');
            replaceImage.attr('src', original)
        }

        trigger.mouseenter(function () {
            replaceImage($(this));
        }).focusin(function () {
            replaceImage($(this));
        })

        $('.nav>ul>li.menu-item').focusout(function () {
            resetImage($(this));
        }).mouseleave(function () {
            resetImage($(this));
        });
    }
});